import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  LineChart,
  YAxis,
  Line,
  ComposedChart,
} from 'recharts';
import styled from 'styled-components';

const category = [
  { name: '기타', value: 8 },
  { name: '떡볶이', value: 14 },
  { name: '일식', value: 18 },
  { name: '피자', value: 24 },
  { name: '치킨', value: 36 },
];
const reversedCategory = [...category].reverse();

const colors = ['#CECECE', '#FF7443', '#FFB53A', '#0D75F8', '#4DD2AE'];

const top5 = [
  { name: '테라 병맥주', value: 300, store: '직영판매' },
  { name: '와인세트 A(행사)', value: 240, store: '직영판매' },
  { name: '후라이드 순살치킨', value: 160, store: '몽몽치킨' },
  { name: '매운 불족발', value: 120, store: '부평족발' },
  { name: '클라우드 병맥주', value: 90, store: '직영판매' },
];

const tickFormatY: any = (tickItem: number) => tickItem.toLocaleString();

const salesDetails = {
  totalCost: 28473570,
  paymentTotal: 22998270,
  storeTotal: 5578320,
  cancelledTotal: 124700,
  orderCnt: 598,
  cancelledCnt: 4,
};

const sales = [
  { name: '직영판매', prev: 3000000, current: 4235000, uv: 3000000, pv: 15000 },
  { name: '우리치킨', prev: 806600, current: 756500, uv: 600000, pv: 300000 },
  { name: '부평족발', prev: 645680, current: 1260000, uv: 500000, pv: 4235000 },
  { name: '바르다분식', prev: 356700, current: 367900, uv: 3000000, pv: 1235000 },
  { name: '성돈', prev: 1609000, current: 532000, uv: 440000, pv: 4235000 },
  { name: '옆집카페', prev: 434500, current: 434500, uv: 500, pv: 600 },
  { name: '몽몽치킨', prev: 899800, current: 1000000, uv: 3000000, pv: 400000 },
  { name: '원기옥', prev: 578000, current: 600000, uv: 500, pv: 4000 },
];

const SalesMonthly = () => {
  const [innerWidth, setInnerWidth] = useState<number>(1000);

  useEffect(() => {
    window.addEventListener('resize', () => setInnerWidth(window.innerWidth * 0.85 * 0.88));
    return () => {
      window.removeEventListener('resize', () => setInnerWidth(window.innerWidth * 0.85 * 0.88));
    };
  }, []);

  const renderCustomizedLabel = (oProps: {
    cx: number;
    cy: number;
    midAngle: number;
    innerRadius: number;
    outerRadius: number;
    name: string;
    value: number;
  }) => {
    const radius = (oProps.innerRadius + oProps.outerRadius) * 0.8;
    const x =
      oProps.cx +
      (radius * Math.cos(-oProps.midAngle * (Math.PI / 180)) * 550) / (oProps.midAngle + 450);
    const y =
      oProps.cy +
      (radius * Math.sin(-oProps.midAngle * (Math.PI / 180)) * 550) / (oProps.midAngle + 450);
    return (
      <>
        <text
          className="sectionLabel"
          x={x}
          y={y}
          fill="white"
          textAnchor="middle"
          dominantBaseline="central">
          {oProps.name}
        </text>
        <text
          className="sectionLabel"
          x={x + 2}
          y={y + 16}
          fill="white"
          textAnchor="middle"
          dominantBaseline="central">
          {oProps.value}%
        </text>
      </>
    );
  };

  return (
    <Style>
      <div className="wideContainer">
        <div className="topContainer">
          <div className="content">
            <h1>
              김노크 사장님, <br />
              이번주 정산금액은
              <span>{`${innerWidth < 900 ? '\n' : ''}3,500,000,000원`}</span>
              입니다
            </h1>
            <div className="analysisContainer">
              <h3>
                지난달 대비 <span>200,000원 증가</span>
              </h3>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_up_red.svg`} alt="ic" />
            </div>
            <div className="boxContainer">
              <div className="box">
                <h4>총 매출</h4>
                <h2>3,000,000원</h2>
              </div>
              <div className="box">
                <h4>결제건수</h4>
                <h2>100건</h2>
              </div>
              <div className="box">
                <h4>고객주문 객단가</h4>
                <h2>35,000원</h2>
              </div>
            </div>
          </div>
          <div className="content">
            <h2>우리매장 인기메뉴</h2>
            <div className="row gap">
              <ResponsiveContainer width={230} height={230} style={{ marginTop: '20px' }}>
                <PieChart>
                  <Pie
                    data={category}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    outerRadius={'100%'}
                    label={renderCustomizedLabel}
                    labelLine={false}
                    startAngle={90}
                    endAngle={450}
                    stroke="none">
                    {category.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <table className="sectionTable">
                <tbody>
                  {reversedCategory.map((item: any, index: number) => {
                    return (
                      <tr key={index}>
                        <div
                          className="ball"
                          style={{ background: colors[colors.length - index - 1] }}
                        />
                        <td>
                          <p>{item.name}</p>
                        </td>
                        <td>
                          <p>10건</p>
                        </td>
                        <td>
                          <p>100,000원</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="content">
            <h2>객단가 변동추이</h2>
            <ResponsiveContainer width="100%" height={230} style={{ marginTop: '20px' }}>
              <LineChart data={sales}>
                <CartesianGrid stroke="rgba(229, 229, 229, 0.4)" vertical={false} />
                <XAxis dataKey="name" axisLine={false} tick={{ fill: '#9F9F9F', fontSize: 12 }} />
                <YAxis
                  type="number"
                  axisLine={false}
                  tick={{ fill: '#9F9F9F', fontSize: 12 }}
                  tickFormatter={tickFormatY}
                  tickLine={false}
                />
                <Tooltip />
                <Line type="linear" dataKey="pv" stroke="#FF7443" strokeWidth={4} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bottomContainer">
          <div className="content">
            <h2>매출•주문</h2>
            <ResponsiveContainer className={'chart'} width="100%" height={300}>
              <ComposedChart data={sales} margin={{ top: 0, right: 5, left: 5, bottom: 10 }}>
                <CartesianGrid stroke="rgba(229, 229, 229, 0.4)" vertical={false} />
                <XAxis dataKey="name" axisLine={false} tick={{ fill: '#9F9F9F', fontSize: 12 }} />
                <YAxis
                  type="number"
                  axisLine={false}
                  tick={{ fill: '#9F9F9F', fontSize: 12 }}
                  tickFormatter={tickFormatY}
                  tickLine={false}
                />
                <Tooltip />
                {/* <Legend /> */}
                {/* <Line type="linear" dataKey="pv" stroke="#FFA031" strokeWidth={4} dot={false} /> */}
                <Bar
                  type="linear"
                  dataKey="pv"
                  barSize={innerWidth < 900 ? 10 : 16}
                  fill="#D9F1EA"
                />
                <Line type="linear" dataKey="uv" stroke="#0D75F8" strokeWidth={4} dot={false} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
          <div className="content">
            <h2>호텔별 클릭수 및 노출수</h2>

            <ResponsiveContainer className={'chart'} width="100%" height={300}>
              <BarChart data={sales} margin={{ top: 0, right: 0, left: 5, bottom: 10 }}>
                <CartesianGrid stroke="rgba(229, 229, 229, 0.4)" vertical={false} />
                <XAxis axisLine={false} dataKey="name" tick={{ fill: '#9F9F9F', fontSize: 12 }} />
                <YAxis
                  type="number"
                  axisLine={false}
                  tick={{ fill: '#9F9F9F', fontSize: 12 }}
                  tickFormatter={tickFormatY}
                  tickLine={false}
                />
                <Tooltip />
                <Bar dataKey="prev" barSize={innerWidth < 900 ? 10 : 16} fill="#E5E5E5" />
                <Bar dataKey="current" barSize={innerWidth < 900 ? 10 : 16} fill="#FFB53A" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </Style>
  );
};

export default SalesMonthly;

const Style = styled.div`
  /* 공통 */
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #2b2b2b;
    line-height: 36px;
  }
  h2 {
    margin-bottom: 5px;
    font-size: 20px;
    font-weight: 600;
    color: #2b2b2b;
  }
  span {
    margin: 0 6px;
    color: #4dd2ae;
  }

  .row.gap {
    gap: 14px;
  }

  /* Container */
  .topContainer,
  .bottomContainer {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 20px;
  }
  .bottomContainer {
    margin-top: 24px;
    gap: 24px;
  }
  .content {
    flex: 1;
    padding: 36px 24px;
    background: #fff;
    border-radius: 10px;
    /* box-shadow: 3px 3px 6px 0px #00000026; */
  }
  .content:nth-child(1) {
    flex: 3;
  }
  .content:nth-child(2) {
    flex: 3;
  }
  .content:nth-child(3) {
    flex: 2;
  }

  /* 이번달 매출 */
  .analysisContainer {
    display: flex;
    align-items: center;
    margin: 16px 0 25px 0;

    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #a7a7a7;
    }
    span {
      color: #ff6464;
    }
  }
  .boxContainer {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 10px;

    .box {
      flex: 1;
      padding: 20px 14px;
      border: 1px solid #dddddd;
      border-radius: 10px;

      h2 {
        margin-bottom: 0;
        font-size: 20px;
        font-weight: 600;
        text-align: center;
      }
      h4 {
        margin-bottom: 16px;
        font-size: 16px;
        white-space: nowrap;
        font-weight: 400;
        color: #000;
        text-align: center;
      }
    }
  }

  /* 그래프 */
  .chart {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .sectionLabel {
    font-size: 14px;
  }
  .sectionTable {
    flex: 1;
    .ball {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
    tr {
      padding: 4px 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    td {
      p {
        color: #555555;
        font-weight: 500;
      }
    }
    td:nth-child(1) {
      width: 10%;
    }
    td:nth-child(2) {
      width: 30%;
    }
    td:nth-child(3) {
      width: 15%;
      text-align: right;
    }
    td:nth-child(4) {
      width: 30%;
      text-align: right;
    }
  }

  @media (max-width: 900px) {
    h1 {
      font-size: 32px;
    }
    h2 {
      margin-bottom: 20px;
    }

    .topContainer,
    .bottomContainer {
      flex-direction: column;
    }
    .content {
      padding: 20px;
      box-shadow: none;
    }
    .boxContainer {
      .box {
        padding: 16px 0;
        h2 {
          font-size: 16px;
        }
        h4 {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
`;
